import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';
import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';
import { redirectToHome } from '../../utilities/helpers';

const disconnectionImg = require('../../../glyphs/error-disconnection.svg');
const errorAMRewards = require('../../../glyphs/rewardsLogo.svg');
const alertImg = require('../../../glyphs/alertOutline.svg');

const mapStateToProps = state => ({
  apiError: state.Manage.apiError,
  country: state.LanguageBundle.country,
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  pnrInfo: state.Manage.pnrInfo,
  storefront: state.Manage.storefront,
  stateStoreFront: state.Manage.stateStoreFront,
});

class ModalErrorTotem extends Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
      width: 0,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleBtnRetryClick = this.handleBtnRetryClick.bind(this);
    this.handleBtnBackToPnr = this.handleBtnBackToPnr.bind(this);
  }

  componentDidMount() {
    const { apiError: { errorData: { code } }, apiError, country, dispatch, pnrInfo } = this.props;
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const typeofPayment = pnrInfo.hasUnpaidAncillary() && pnrInfo.hasUnpaidAncillaryPP() ? 'With points and money' : pnrInfo.hasUnpaidAncillaryPP() ? 'Points' : 'Money';
    const extraInfo = {
      storefront: country,
      pnrInfo: pnrInfo.pnrCode,
      typeofPayment,
      numPax: pnrInfo.getAllPassengers().length,
      CPmis: pnrInfo.cart.getUnPaidAncillariesCP().length,
    };
    if (code === '13430701' || code === '13330701') {
      dispatch(sendAnalytics({
        eventCreator: manageTracking.errorCPTracking(apiError, extraInfo),
      }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    const { apiError: { errorData: { code } } } = this.props;
    const errorType = (code === '13430701' || code === '13111321') ? 'CLUB_PREMIER' : code === '13330701' ? 'DESCONEXION_CP' : 'OTRO';
    return (
      <div className='ErrorModal'>
        <div className='Modal-Baggage'>
          <div className='Modal-Baggage__container'>
            { errorType === 'CLUB_PREMIER' ? this.renderErrorCp(code) : this.renderError() }
          </div>
        </div>
      </div>
    );
  }

  renderErrorCp(code) {
    return (
      <div className='ErrorRetryModal--disconnectionTwo'>
        <div className='ErrorRetryModal-main--disconnection'>
          <div className='ErrorRetryModal-contenedorImg'>
            <img
              alt='Disconnection'
              className='ErrorRetryModal-imgError'
              src={ errorAMRewards }
            />
            <img
              alt='alertImg'
              className='ErrorRetryModal-imgError-alert'
              src={ alertImg }
            />
          </div>
          <TranslatedCopy
            className='ErrorRetryModal-body--disconnectionCp'
            copyID='MYB_ERROR_PAYMENTS_DECLINED'
            tagName='p' />
          <TranslatedCopy
            className='ErrorRetryModal-heading--disconnectionThree'
            copyID='MYB_ERROR_PAYMENTS_POINTS'
            tagName='h5' />
          <TranslatedCopy
            className='ErrorRetryModal-body--disconnectionError'
            copyID='MYB_ERROR_PAYMENT_TRY_AGAIN'
            tagName='p'
          />
          {/* <TranslatedCopy
            className='ErrorRetryModal-body--linkError'
            copyID='MYB_ERROR_CHANGE_PAYMENT'
            tagName='p'
          /> */}
        </div>
        <div className='ModalCta--disconnectionCp'>
          <div className='ErrorRetryModal-wrapActions'>
            <div className='Form-submit EmailPNRInfo-saveButton'>
              <Btn
                className='ErrorModal-btn'
                onBtnClick={ () => window.location.reload() }
                filledRed={ true }
                copyID={ code === '13111321' ? 'MYB_TRY_AGAIN_MODAL' : 'APP_CLOSE' } />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    const {
      isActiveFlowCorporate,
      stateStoreFront,
    } = this.props;

    return (
      <div className='ErrorRetryModal--disconnectionTwo'>
        <div className='ErrorRetryModal-main--disconnection'>
          <div className='ErrorRetryModal-contenedorImg'>
            <img
              src={ disconnectionImg }
              alt='Disconnection'
              className='ErrorRetryModal-imgError'
            />
          </div>
          <TranslatedCopy
            className='ErrorRetryModal-body--disconnectionTwo'
            copyID='MYB_ERROR_LOST_CONECTION'
            tagName='p' />
          <TranslatedCopy
            className='ErrorRetryModal-heading--disconnectionThree'
            copyID='MYB_ERROR_DESCONECTION_RESTABLISHED'
            tagName='h5' />
          <TranslatedCopy
            className='ErrorRetryModal-body--disconnectionError'
            copyID='MYB_ERROR_CALLCENTER_DESCONECTION'
            tagName='p'
            CallcenterPhone={ isActiveFlowCorporate ? <TranslatedCopy copyID='C&C_Corp_CallCenterNumer' /> : stateStoreFront.contactNumber }
          />
        </div>
        <div className='ModalCta--disconnection'>
          <div className='ErrorRetryModal-wrapActions'>
            <div className='Form-submit EmailPNRInfo-saveButton'>
              <Btn
                className='ErrorModal-btn'
                onBtnClick={ this.handleBtnBackToPnr }
                filled={ true }
                copyID='MYB_ERROR_BACK_TO_HOME' />
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleBtnRetryClick() {
    const {
      closePaymentErrorModal,
    } = this.props;

    closePaymentErrorModal();
  }

  handleBtnBackToPnr() {
    const {
      apiError,
      stateStoreFront,
      storefront,
    } = this.props;

    // Looking for upgrade voucher error to reload page
    if (apiError?.actionType === 'SET_UPGRADE_VOUCHER_FAIL' && apiError?.errorData?.actionable === 'CONTINUE') {
      window.location.reload();
    } else {
      setTimeout(() => {
        window.location = redirectToHome(storefront, stateStoreFront?.staticLinks?.headerMyTrips);
      }, 1000);
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }
}

ModalErrorTotem = connect(mapStateToProps)(ModalErrorTotem);

export default ModalErrorTotem;
